/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  Loading,
  FormGroup,
  ComposedModal,
  DatePickerSkeleton,
  TextArea,
  Button,
  DataTable,
  Pagination,
  DataTableSkeleton,
  Table,
  TableHeader,
  TableHead,
  TableRow,
  TableContainer,
  TableBody,
  TableCell,
  TextInput,
  FormLabel,
} from 'carbon-components-react';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import View16 from '@carbon/icons-react/lib/view--filled/16';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import SimpleReactValidator from 'simple-react-validator';
import { Link } from 'react-router-dom';
import {
  RenderDataTableCell,
  NoRecordsPlaceholder,
} from '../../../../helpers/jsonschemaform/DataTableExtention';
import { FindGHRSEmployer } from '../../../common/FindGHRSEmployer';
import PageBreadCrumb from '../../../../helpers/PageBreadCrumb';
import { IsEditable } from '../../../../helpers/authorization/Policies';
import { showNotification } from '../../../../helpers/notification/BaseNotification';
import {
  DateFormat,
  entitiesLabels,
  getError,
  apioperation,
  getSuccess,
} from '../../../../helpers/Constants';
import DateTimePicker from '../../../../helpers/DateTimePicker';
import { api } from '../../../../helpers/api/api';
import { AppContext } from '../../../../helpers/context/AppContext';
import DrillRepository from '../../../../helpers/api/DrillRepository';
import { Online, Offline } from '../../../common/OnLineOffLine';
import { FindSaipemCompilers } from '../../../common/FindSaipemCompilers';

export class DrillCarList extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.state = {
      isOpenModalGHRS: false,
      drillKey: this.props.match.params.id,
      drillCode: null,
      drillCarModel: null,
      drillReport: {},
      carList: [],
      mode: 0,
      isOpenModalCar: false,
      isLoadingElement: false,
      isLoadingDate: false,

      currentPage: 1,
      pageSize: 10,
      rowCount: 0,
    };

    this.baseUrl = '/drill/report';

    this.handleChangeGHRSModal = this.handleChangeGHRSModal.bind(this);
    this.setEmployer = this.setEmployer.bind(this);
    this.getIsEditable = this.getIsEditable.bind(this);
    this.getCanEditResource = this.getCanEditResource.bind(this);
    this.handleCarDeleteCancel = this.handleCarDeleteCancel.bind(this);
    this.onDetailsOfInefficiencyChange = this.onDetailsOfInefficiencyChange.bind(this);
    this.onFindingDescriptionChange = this.onFindingDescriptionChange.bind(this);
    this.onCorrectiveActionChange = this.onCorrectiveActionChange.bind(this);
  }

  baseUrl;

  componentDidMount() {
    this.getCarList(this.state.drillKey);
  }

  getCarList(id) {
    this.setState({
      isLoadCar: true,
    });
    const dataInput = {
      params: {
        page: this.state.currentPage,
        pageSize: this.state.pageSize,
      },
     };
    api
      .getWithParam(`drill/report/${id}/car`, dataInput)
      .then((response) => {
        if (response.status === 200) {
          const { data } = response;
          if (data) {
            this.setState({
              carList: data.drillCAR.itemList,
              drillReport: data.drillReport,
              drillCode: data.drillCode,
              page: data.drillCAR.currentPage,
              pageSize: data.drillCAR.pageSize,
              pageCount: data.drillCAR.pageCount,
              rowCount: data.drillCAR.rowCount,
            });
          } 
        }
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.CAR, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadCar: false,
          isLoadingElement: false,
        });
      });
  }

  handleChangePaging = async (page) => {
    await new Promise((resolve) => {
      this.setState({ currentPage: page.page, 
                      pageSize: page.pageSize, 
                      loading: true, 
                      isBack: false }, resolve);
    });
    this.getCarList(this.state.drillKey);
  };

  updateCAR() {
    if (this.validator.allValid()) {
    const car = this.state.drillCarModel;
    car.idDrillReport = this.state.drillReport.id;
    if (car.id == null) return;
    const url = this.getUrlDetailCar(car.id);
    api
      .put(url, car, '')
      .then(async (response) => {
        if (response.status === 200) {
          showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.CAR, apioperation.PUT));
          await DrillRepository.updateCachedCarList(car);
          const id = this.state.drillKey;
          this.getCarList(id);
          this.closemodalCar();
        }
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.CAR, apioperation.PUT));
      })
      .finally(() => {});
    } else {
      this.validator.showMessages();
      showNotification.warning(`${entitiesLabels.WARNING}`,
        `${entitiesLabels.EMERGENCYDRILL_REPORT} required fields are missing  `
      );

      this.forceUpdate();
    }
  }

  handleCarDeleteCancel() {
    this.setState({
      idToDelete: null,
      isOpenDeleteModal: false,
      isDeleting: false,
    });
  }

  confirmDeleteCAR = (id) => {
    this.setState({
      idToDelete: id,
      isOpenDeleteModal: true,
      isDeleting: false,
    });
  };

  confirmDeleteCar = () => 
    // const modalHeader = {
    //   title: 'Delete Car',
    //   iconDescription: 'Close',
    //   buttonOnClick: () => this.handleRequirementDeleteCancel(),
    // };
     (
      this.state.isOpenDeleteModal && (
        <ComposedModal
          className="light-modal"
          open
          danger="false"
          onClose={() => {
            this.handleCarDeleteCancel();
          }}
        >
          <ModalHeader className="margin-modal" title="Delete Car" iconDescription="Close" buttonOnClick={() => this.handleRequirementDeleteCancel()}>
            <p />
          </ModalHeader>
          <ModalBody className="margin-modal">
            <div className="bx--grid--full-width">
              <div className="bx--row">
                <div className="bx--col-lg-12 bx--col-md-12">
                  <h5 className="align-center">Press confirm to delete car selected </h5>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button kind="secondary" onClick={this.handleCarDeleteCancel}>
              Cancel
            </Button>
            <Button kind="primary" onClick={() => this.deleteCAR()}>
              Confirm
            </Button>
          </ModalFooter>
        </ComposedModal>
      )
    )
  ;

  deleteCAR() {
    const item = this.state.carList.find((el) => el.id === this.state.idToDelete);

    const url = `${this.baseUrl}/${this.state.drillReport.id}/answer/${item.idAnswer}/car/${item.id}`;
    api
      .delete(url, '')
      .then((response) => {
        if (response.status === 200) {
          showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.CAR, apioperation.DELETE));
          const id = this.state.drillKey;
          this.getCarList(id);
          this.setState({
            isOpenDeleteModal: false,
          });
        }
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.CAR, apioperation.DELETE));
      })
      .finally(() => {});
  }

  updateState = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state };
    statusCopy[objName][inputName] = inputValue;
    this.setState(statusCopy);
  };

  getUrlDetailCar = (id) => {
    if (id == null) return '#';
    return `${this.baseUrl}/answer/car/${id}`;
  };

  getStatusId = (idRow) => {
    const r = this.state.carList.find((el) => el.id === idRow);
    return r && r.idStatus;
  };

  getCanEditResource = () => {
    const canEditResource = this.state.drillReport && {
      idCompiler: this.state.drillReport.idCompiler,
    };

    return canEditResource;
  };

  getIsEditable() {
    const reportStatus = this.state.drillReport.idStatus;
    if (reportStatus < 4) return true;

    return false;
  }

  // getUrlBack = () => {
  //   if (this.state.drillReport?.id != null) {
  //     return this.props.history.goBack();
  //   }
  // };

  render() {
    const headersArr = [
      { key: 'drillCARCode', header: 'Code' },
      { key: 'requirementCode', header: 'Requirement Code' },
      { key: 'owner', header: 'Owner' },
      { key: 'duedate', header: 'Due Date', type: 'date' },
      { key: 'status', header: 'Status', type: 'status' },
    ];
    const skeletonRowCount = 3;

    const rowsArr = [];

    if (this.state.carList) {
      const cars = this.state.carList.sort((a, b) => {
        const sequenceA = new Date(a.sequence);
        const sequenceB = new Date(b.sequence);
        return sequenceA - sequenceB;
      });
      cars.forEach((item) => {
        rowsArr.push({
          id: item.id,
          idAnswer: item.drillCheckListRequirementAnswer.idAnswer,
          drillCARCode: item.drillCARCode,
          requirementCode: item.requirementCode,
          status: item.status.carSimplifiedName,
          owner:
            item.owner != null
              ? `${item.owner.name} ${item.owner.surname}`
              : `${item.ownerSaipem.name} ${item.ownerSaipem.surname}`,
          duedate: item.dueDate,
        });
      });
    }
    // const paginationProps = () => ({
    //   page: this.state.currentPage || 1,
    //   totalItems: this.state.rowCount || 0,
    //   pageSize: this.state.pageSize || 10,
    //   pageSizes: [10, 20, 30, 40, 50],
    //   onChange: this.handleChangePaging,
    // });
    return (
      <AppContext.Consumer>
        {({ user }) => (
          <>
            <PageBreadCrumb
              linkTo={`/drill/report/${this.state.drillKey}`}
              linkText="Drill Report"
              titleLeft={`Drill Report Id: ${
                this.state.drillReport?.drillReportCode || ''
              } - CAR List`}
              // onClick={this.getUrlBack}
            />
            <div className="mainContainer">
              {this.modalCar()}
              {this.confirmDeleteCar()}
              {this.state.isLoadCar ? (
                <DataTableSkeleton
                  headers={[]}
                  rowCount={skeletonRowCount}
                  zebra={false}
                  compact={false}
                />
              ) : (
                <DataTable
                  useZebraStyles
                  rows={rowsArr || []}
                  headers={headersArr}
                  render={({ rows, headers, getHeaderProps, getRowProps }) => (
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            {headers.map((header) => (
                              <TableHeader {...getHeaderProps({ header })}>
                                {header.header}
                              </TableHeader>
                            ))}
                            <TableHeader className="align-center">Actions</TableHeader>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows == null || rows.length === 0 ? (
                            <NoRecordsPlaceholder colSpan={headers.length + 2} />
                          ) : (
                            rows.map((row) => (
                              <TableRow {...getRowProps({ row })}>
                                {row.cells.map((cell) => (
                                  <RenderDataTableCell
                                    key={cell.id}
                                    cell={cell}
                                    header={headers.find((x) => x.key === cell.info.header)}
                                  />
                                ))}

                                <TableCell
                                  key={`action-${row.id}`}
                                  className="tableActions align-center"
                                >
                                  <div>
                                    {IsEditable(
                                      'Emergency Drill',
                                      'CARSimplified',
                                      user,
                                      this.getStatusId(row.id),
                                      'DueDate',
                                      this.getCanEditResource(null)
                                    ) && this.getIsEditable(row.id) ? (
                                      <>
                                        <Button
                                          onClick={() => this.getCAR(this.getUrlDetailCar(row.id))}
                                          size="small"
                                          renderIcon={Edit16}
                                          iconDescription="Edit"
                                          kind="ghost"
                                        />
                                        <Online>
                                          <Button
                                            onClick={() => this.confirmDeleteCAR(row.id)}
                                            size="small"
                                            renderIcon={Delete16}
                                            iconDescription="Delete"
                                            kind="ghost"
                                          />
                                        </Online>
                                        {' '}
                                        <Offline>
                                          <Button
                                            size="small"
                                            renderIcon={Delete16}
                                            iconDescription="delete disabled you're offline"
                                            kind="ghost"
                                            disabled
                                          />
                                        </Offline>
                                      </>
                                    ) : null}

                                    <Link to={this.getUrlDetailCar(row.id)}>
                                      <Button
                                        size="small"
                                        renderIcon={View16}
                                        iconDescription="Detail"
                                        kind="ghost"
                                      />
                                    </Link>
                                  </div>
                                </TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                />
              )}
              <div className="footer-pagination">
                <Pagination 
                  page={this.state.currentPage || 1} 
                  totalItems={this.state.rowCount || 0} 
                  pageSize={this.state.pageSize || 10}
                  pageSizes={[10, 20, 30, 40, 50]}
                  onChange={this.handleChangePaging}
                />
              </div>
            </div>
          </>
        )}
      </AppContext.Consumer>
    );
  }

  setEmployer = (employer) => {
    if (employer && employer.id) {
      this.setState((prevState) => {
        const statusCopy = { ...prevState.drillCarModel };
        statusCopy.idOwner = employer.id;
        statusCopy.owner = employer;
        statusCopy.idOwnerSaipem = null;
        statusCopy.ownerSaipem = null;
        return { drillCarModel: statusCopy, mode: 0 };
      });
    }
  };

  setSaipemOwner = (employer) => {
    if (employer && employer.id) {
      this.setState((prevState) => {
        const statusCopy = { ...prevState.drillCarModel };
        statusCopy.idOwnerSaipem = employer.id;
        statusCopy.ownerSaipem = employer;
        statusCopy.idOwner = null;
        statusCopy.owner = null;

        return { drillCarModel: statusCopy, mode: 0 };
      });
    }
  };

  handleChangeMode = (m) => {
    this.setState({ mode: m });
  };

  showGHRS = () => {
    this.setState({ mode: 1 });
  };

  handleChangeGHRSModal() {
    this.setState({ mode: 0 });
  }

  closemodalCar = () => {
    this.validator.hideMessages();
    this.forceUpdate();
    this.setState({ isOpenModalCar: false });
  };

  getCAR = (url) => {
    this.setState({
      isLoading: true,
    });
    api
      .get(url, '')
      .then((response) => {
        const { data } = response;
        if (data) {
          this.setState({
            drillCarModel: data,
            isOpenModalCar: true,
          });
        } else {
          showNotification.error(`${entitiesLabels.ERROR}`, 'CAR not found');
        }
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.CAR, apioperation.GET));
        this.props.history.push(this.baseUrl);
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  updateStateDPCAR = (inputName, inputValue) => {
    this.setState((prevState) => ({ drillCarModel: {
        ...prevState.drillCarModel,
        dueDate: inputValue,
      } }));
  };

  onDetailsOfInefficiencyChange(event) {
    const { value } = event.currentTarget;
    this.setState((prevState) => ({
      drillCarModel: {
        ...prevState.drillCarModel,
        detailsOfInefficiency: value,
      }
    }));
  }

  onFindingDescriptionChange(event) {
    const { value } = event.currentTarget;
    this.setState((prevState) => ({ drillCarModel: {
        ...prevState.drillCarModel,
        findingDescription: value,
      } }));
  }

  onCorrectiveActionChange(event) {
    const { value } = event.currentTarget;
    this.setState((prevState) => ({ drillCarModel: {
        ...prevState.drillCarModel,
        identifiedCorrectiveAction: value,
      } }));
  }

  getOwner = () => {
    if (this.state.drillCarModel?.owner) return `${this.state.drillCarModel.owner.name} ${this.state.drillCarModel.owner.surname}`;
    if (this.state.drillCarModel?.ownerSaipem) return `${this.state.drillCarModel.ownerSaipem.name} ${this.state.drillCarModel.ownerSaipem.surname}`;
    return '';
  };

  modalCar() {
    // const modalHeader = {
    //   title: `Edit Drill Car: ${this.state?.drillCarModel?.drillCARCode}`,
    //   iconDescription: 'Close',
    //   buttonOnClick: () => this.closemodalCar(),
    // };
    const validationCar = {
      findingDescription: this.validator.message(
        'Finding Description',
        this.state.drillCarModel?.findingDescription,
        'required'
      ),
      correctiveAction: this.validator.message(
        'Corrective Action to be implemented',
        this.state.drillCarModel?.identifiedCorrectiveAction,
        'required'
      ),
    };
    if (this.state.mode === 1) {
      return (
        <FindGHRSEmployer
          isOpenModal={this.state.isOpenModalCar}
          onCancel={() => this.handleChangeMode(0)}
          onOk={this.setEmployer}
        />
      );
    }
    if (this.state.mode === 2) {
      return (
        <FindSaipemCompilers
          isOpenModal={this.state.isOpenModalCar}
          url={`/drill/report/${this.state.drillReport?.idDrillPlan}/car/compilers/`}
          onCancel={() => this.handleChangeMode(0)}
          onOk={this.setSaipemOwner}
        />
      );
    }

    return (
      <ComposedModal
        className="light-modal"
        open={this.state.isOpenModalCar}
        danger="false"
        onClose={() => false}
      >
        <ModalHeader 
          className="margin-modal" 
          title={`Edit Drill Car: ${this.state?.drillCarModel?.drillCARCode}`}
          iconDescription="Close"
          buttonOnClick={() => this.closemodalCar()}
        >
          <p />
        </ModalHeader>
        <ModalBody className="margin-modal">
          <div className="bx--grid--full-width">
            <div className="bx--row">
              <Form className="bx--grid--full-width form--multi ">
                {this.state.isLoadingElement ? <Loading /> : ''}
                <div className="bx--row ">
                  <FormGroup legendText="" className="bx--col-md-4">
                    <FormLabel className="some-class">Due Date*</FormLabel>
                    {this.state.isLoadingDate ? (
                      <DatePickerSkeleton />
                    ) : (
                      <DateTimePicker
                        value={this.state.drillCarModel?.dueDate}
                        type="date"
                        placeholder={DateFormat}
                        name="dueDate"
                        alt="carModel"
                        // invalid={validations.duedate != null}
                        onChange={this.updateStateDPCAR}
                      />
                    )}
                  </FormGroup>

                  <FormGroup legendText="Find Owner on GHRS or Saipem*">
                    <div className="bx--row two-button-center">
                      <div className="bx--col-lg-6 bx--col-md-6">
                        <Button
                          kind="primary"
                          className="bx--col"
                          onClick={() => this.handleChangeMode(1)}
                        >
                          GHRS research
                        </Button>
                      </div>
                      <div className="bx--col-lg-6 bx--col-md-6 ">
                        <Button
                          kind="primary"
                          className="bx--col button--line--content"
                          onClick={() => this.handleChangeMode(2)}
                        >
                          Saipem research
                        </Button>
                      </div>
                    </div>
                  </FormGroup>

                  <FormGroup legendText="" className="bx--col-md-4">
                    <FormLabel className="some-class">Owner Full Name*</FormLabel>
                    <TextInput
                      id={this.getOwner()}
 
                      name="idEmployer"
                      placeholder="Search Car Owner"
                      required
                      value={this.getOwner()}
                      onChange={this.handleChangeModelCar}
                      type="text"
                      labelText=""
                      className="bx--text-input  bx--text-input--light camp--description "
                      disabled
                      //  invalid={validations.descriptionCar != null}
                    />
                  </FormGroup>
                  <FormGroup legendText="" className="bx--col-md-4">
                    <FormLabel className="some-class">Owner Email*</FormLabel>
                    <TextInput
                      id={this.getOwner()}
                      name="idEmployer"
                      placeholder="Search Car Owner"
                      required
                      value={this.getOwner()}
                      onChange={this.handleChangeModelCar}
                      type="text"
                      labelText=""
                      className="bx--text-input  bx--text-input--light camp--description "
                      disabled
                      //  invalid={validations.descriptionCar != null}
                    />
                  </FormGroup>
                  <FormGroup legendText="Finding Description*">
                    <TextArea
                      maxLength={5000}
                      labelText=""
                      id="inputfindingDescription"
                      name="inputfindingdescription"
                      cols={250}
                      disabled={false}
                      invalid={validationCar.findingDescription}
                      light
                      placeholder="Input Finding description"
                      rows={5}
                      value={this.state.drillCarModel?.findingDescription || ''}
                      onChange={this.onFindingDescriptionChange}
                    />
                  </FormGroup>
                  {validationCar.findingDescription}
                  <FormGroup legendText="Details Of Inefficiency*">
                    <TextArea
                      maxLength={5000}
                      labelText=""
                      id="inputDetailOfInefficiency"
                      name="inputdetailsofinefficiency"
                      cols={250}
                      disabled={false}
                      invalid={false}
                      invalidText="required"
                      light
                      placeholder="Input Details of Inefficiency"
                      rows={5}
                      value={this.state.drillCarModel?.detailsOfInefficiency}
                      onChange={this.onDetailsOfInefficiencyChange}
                    />
                  </FormGroup>
                  <FormGroup legendText="Corrective Action to be implemented/Recommended action*">
                    <TextArea
                      maxLength={5000}
                      labelText=""
                      id="inputCorrectiveAction"
                      name="inputcorrectiveaction"
                      cols={250}
                      disabled={false}
                      invalid={validationCar.correctiveAction}
                      light
                      placeholder="Input Corrective Action to be implemented/Recommended action"
                      rows={5}
                      value={this.state.drillCarModel?.identifiedCorrectiveAction || ''}
                      onChange={this.onCorrectiveActionChange}
                    />
                  </FormGroup>
                  {validationCar.correctiveAction}
                </div>
              </Form>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button kind="secondary" onClick={() => this.closemodalCar()}>
            Cancel
          </Button>
          <Button kind="primary" onClick={() => this.updateCAR()}>
            Save
          </Button>
        </ModalFooter>
      </ComposedModal>
    );
  }
}

DrillCarList.propTypes = {
  history: PropTypes.shape({
    length: PropTypes.number,
    action: PropTypes.string,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      search: PropTypes.string,
      hash: PropTypes.string,
      state: PropTypes.object
    }),
    index: PropTypes.number,
    entries: PropTypes.array,
    createHref: PropTypes.func,
    push: PropTypes.func,
    replace: PropTypes.func,
    go: PropTypes.func,
    goBack: PropTypes.func,
    goForward: PropTypes.func,
    canGo: PropTypes.func,
    block: PropTypes.func,
    listen: PropTypes.func
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string,
      }),
    }).isRequired,
};

export default DrillCarList;
